<template>
  <div class="advantages">
    <div class="advantages__inner container wc-lg">
      <h2 class="f-18 bold uppercase">{{ _.get(this.content, "title") }}</h2>
      <div
        class="advantages__row"
        v-for="(row, index) in _.get(this.content, 'content.tabs')"
        :key="index"
      >
        <div
          v-html="row.content"
          :class="{ advantages__row_2: index === 1 }"
        ></div>
        <a
          :href="'mailto:' + _.get(row, 'link')"
          class="advantages__btn button bg-light-purple f-white"
          v-if="index == 1"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11.352"
            height="11.351"
            viewBox="0 0 11.352 11.351"
          >
            <path
              id="Combined_Shape_Copy_2"
              data-name="Combined Shape Copy 2"
              d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
              fill="#fff"
            />
          </svg>

          {{ _.get(row, "link_name") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contentData"],
  computed: {
    content() {
      return _.get(this.contentData, "data.list[0]");
    }
  },
  mounted() {
    console.log(this.content);
  }
};
</script>

<style></style>
